import React, { useEffect, useState } from 'react';
import { API_URL, ENDPOINTS, postData } from '../../constants/api';
import { Link } from 'react-router-dom';
import { updateColumn } from '../../constants/functions';
import ModalForm from '../../components/ModalForm';
import { decodeToken, getToken } from '../../utils/TokenUtils';

export default function PatientTabs({ appointmentId }) {
  const [sections, setSections] = useState([]);
  const [activeTab, setActiveTab] = useState('All');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const [currentRoute, setCurrentRoute] = useState('');
  const [queryParams, setQueryParms] = useState('');
  const [isModalFormOpen, setIsModalFormOpen] = useState(false);

  const token = getToken();
  const user_id = decodeToken(token, 'id');

  useEffect(() => {
    if (!appointmentId) return;

    const fetchData = async () => {
      setLoading(true);
      setError(null);
      try {
        const url = `${API_URL}/${ENDPOINTS.SYS}/activityReport/patient-history`;
        const body = { appointment_id: appointmentId };
        const response = await postData(url, body);
        // console.log('body:', body);
        const data = response.data || [];

        setSections(data);
      } catch (err) {
        setError('Failed to load data ' + err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [appointmentId]);

  if (!appointmentId) return <p>Please select an appointment</p>;
  if (loading) return <p>Loading...</p>;
  if (error) return <p className="text-danger">{error}</p>;

  const renderFields = (fields) => (
    <div className="row">
      {Object.entries(fields).map(([key, value]) => (
        <div key={key} className="col-md-12 mb-2">
          <strong>{key}:</strong> {value}
        </div>
      ))}
    </div>
  );

  const renderTable = (title, rows) => (
    <div className="mb-4">
      {/* <h5>{title}</h5> */}
      {rows.length === 0 ? (
        <p>No records found.</p>
      ) : (
        <table className="table table-striped">
          <thead>
            <tr>
              {Object.keys(rows[0]).map((key) => (
                <th key={key}>{key}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {rows.map((row, idx) => (
              <tr key={row.id || idx}>
                {Object.values(row).map((value, i) => (
                  <td key={i}>{value}</td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );

  const renderSection = (section) => (
    <div key={section.title} className="mb-4">
      <h4>{section.title}</h4>
      {section.fields && renderFields(section.fields)}
      {Array.isArray(section.table) &&
        renderTable(section.title, section.table)}
    </div>
  );

  const openFormModal = (route, queryParams) => {
    setCurrentRoute(route);
    setQueryParms(queryParams);
    // setUpdateTable()
    setIsModalFormOpen(true);
  };
  const closeFormModal = () => {
    setIsModalFormOpen(false);
  };

  const href = `updatecolumn/caafi_appointment/${appointmentId}/type/in`;
  return (
    <div className="container p-3">
      <div className="mb-3">
        <Link
          to={`/multi-entry/Presciption-Multi?appointment_id=${appointmentId}`}
          className="btn btn-primary me-2"
        >
          Prescription
        </Link>

        <Link
          to={`/lab-test-request/${appointmentId}`}
          className="btn btn-warning me-2"
        >
          Lab Request
        </Link>

        <button
          className={`btn btn-danger me-2`}
          onClick={(e) => updateColumn(e, href)}
        >
          Make In patient
        </button>

        <button
          className="btn btn-success me-2"
          onClick={(e) =>
            openFormModal(
              'register-appointment_notes',
              'appointment_id=' + appointmentId
            )
          }
        >
          Doctor Notes
        </button>
        {isModalFormOpen && currentRoute && (
          <ModalForm
            userId={user_id}
            token={token}
            queryParams={queryParams}
            route={currentRoute} // Pass the dynamic route to the modal
            isOpen={isModalFormOpen}
            onRequestClose={closeFormModal}
          />
        )}
      </div>

      {/* Tabs */}
      <ul className="nav nav-tabs mb-3">
        <li className="nav-item">
          <button
            className={`nav-link ${activeTab === 'All' ? 'active' : ''}`}
            onClick={() => setActiveTab('All')}
          >
            All
          </button>
        </li>
        {sections.map((section) => (
          <li key={section.title} className="nav-item">
            <button
              className={`nav-link ${
                activeTab === section.title ? 'active' : ''
              }`}
              onClick={() => setActiveTab(section.title)}
            >
              {section.title}
            </button>
          </li>
        ))}
      </ul>

      {/* Tab Content */}
      {activeTab === 'All'
        ? sections.map((section) => renderSection(section))
        : sections
            .filter((section) => section.title === activeTab)
            .map((section) => renderSection(section))}
    </div>
  );
}
